<div class="home-block light" id="what-is-szebit">
  <div class="home-container d-flex-decor">
    <div class="movementInit movement">
      <div *appFadeInOnScroll class="fadeInit fadeInLeft decor-rectangle" id="what-is-szebit-decor">
        <p>Mi a SZEBIT?</p>
        <hr />
      </div>
    </div>
    <div *appFadeInOnScroll class="fadeInit fadeInRight">
      <h2 class="orange">Több mint technológiai konferencia. Találkozási pont.</h2>
      <p style="max-width: 596px; line-height: 2rem">
        A Szeged Business & IT – SzeBIT immár nyolcadik alkalommal hozza össze Szegeden a
        technológiai szektor, az üzleti élet és a közszféra szereplőit.
      </p>
    </div>
  </div>
  <div class="home-container longtext">
    <div *appFadeInOnScroll class="fadeInit fadeInLeft">
      <p
        >Egy nap, amikor nemzetközi technológiai gyártók, IT-szakemberek, vállalati és intézményi
        döntéshozók, szakértők és a jövő technológiái iránt érdeklődők találkoznak egymással.
      </p>
      <p
        >A SzeBIT célja kezdettől több egy hagyományos szakmai konferenciánál. Olyan vidéki
        technológiai találkozópontot épít, amely közelebb hozza a legújabb innovációkat és a
        globális technológiai trendeket a régió vállalkozásaihoz, intézményeihez és
        szakembereihez.</p
      >
      <p class="turquoise"
        >Előadások. Szakmai párbeszéd. Technológiai kiállítás. Üzleti kapcsolatok. Valódi
        találkozások.</p
      >
    </div>

    <div *appFadeInOnScroll class="fadeInit fadeInRight">
      <h3 class="turquoise">2026-ban pedig: Beyond Digital </h3>
      <p
        >A digitalizáció mára működésünk természetes részévé vált. A mesterséges intelligencia, az
        automatizáció, az adatvezérelt működés és az intelligens technológiák azonban már egy új
        korszakot formálnak.
      </p>
      <p class="font-bold">A SzeBIT 2026 arra keresi a választ, mi jön a digitalizáció után.</p>
    </div>
  </div>
</div>

<div class="home-block">
  <div class="home-container longtext">
    <div *appFadeInOnScroll class="fadeInit fadeInLeft">
      <h2 class="orange">Mit ad a SZEBIT 2026?</h2>
      <h2>Egy nap. Több nézőpont. Közös jövő.</h2>
      <p>
        A SzeBIT-en a technológia nemcsak téma, hanem megtapasztalható valóság. Előadások, szakmai
        beszélgetések, innovatív technológiai megoldások és személyes találkozások mutatják meg,
        hogyan formálja át a digitalizáció és a mesterséges intelligencia a következő éveket.
      </p>
      <ul>
        <li>
          <b>INNOVÁCIÓS KIÁLLÍTÁS:</b
          ><span class="turquoise"> Nézd meg. Próbáld ki. Tapasztald meg.</span> Ismerd meg
          testközelből a meghatározó technológiai gyártók legújabb fejlesztéseit, AI-alapú
          megoldásait és digitális innovációit. A SzeBIT kiállítási tere idén még látványosabb,
          digitálisabb megjelenésekkel várja a látogatókat.
        </li>
        <li>
          <b>KIEMELT ELŐADÁSOK:</b
          ><span class="turquoise"> Gondolatok azoktól, akik alakítják a változást.</span> Iparági
          szakértők, technológiai véleményformálók és a meghatározó IT-gyártók képviselői hozzák el
          a SzeBIT színpadára azokat a trendeket, kérdéseket és megoldásokat, amelyek már ma
          formálják a holnap működését.
        </li>
        <li>
          <b>SZAKMAI BESZÉLGETÉSEK:</b
          ><span class="turquoise">
            Nem csak előadunk. Kérdezünk és ütköztetjük a véleményeket.</span
          >
          Mit változtat meg valójában a mesterséges intelligencia? Hol jelent valódi előrelépést a
          digitalizáció – és hol vet fel új kérdéseket? A SzeBIT pódiumbeszélgetéseiben különböző
          területek szakértőivel járjuk körül a technológiai változás lehetőségeit, kihívásait és
          emberi oldalát.
        </li>
        <li>
          <b>NETWORKING:</b>
          <span class="turquoise">
            Mert a legjobb beszélgetések nem mindig a színpadon történnek.</span
          >
          A SzeBIT egyben találkozási pont is. Lehetőség arra, hogy technológiai gyártók,
          szakemberek, vállalati és intézményi döntéshozók találkozzanak, tapasztalatot cseréljenek
          és új szakmai, üzleti kapcsolatok induljanak el.
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="home-block light">
  <div class="home-container">
    <h1>Kinek szól a SZEBIT?</h1>
    <h2>Ha a technológia része a munkádnak, a döntéseidnek vagy a jövődnek, itt a helyed.</h2>
    <p
      >A SzeBIT különböző területek szereplőit hozza közös térbe. Azokat, akik technológiai
      döntéseket hoznak, azokat, akik fejlesztik és alkalmazzák az új megoldásokat – és azokat is,
      akik szeretnék megérteni, hogyan változtatja meg mindez a következő éveket.</p
    >
    <div *appFadeInOnScroll class="fadeInit fadeInLeft">
      <ul>
        <li>
          <b>VÁLLALATI DÖNTÉSHOZÓKNAK:</b
          ><span class="turquoise">
            Akik nemcsak követni, hanem alakítani szeretnék a változást.</span
          >
          Cégvezetőknek és üzleti döntéshozóknak, akik szeretnék látni, milyen technológiák
          formálják vállalatuk működését, versenyképességét és jövőjét.
        </li>
        <li>
          <b>IT-SZAKEMBEREKNEK:</b
          ><span class="turquoise"> Akik számára a jövő technológiája már a jelen feladata.</span>
          Informatikai vezetőknek, IT-szakembereknek és technológiai döntéshozóknak, akik első
          kézből szeretnék megismerni az új megoldásokat, trendeket és a meghatározó gyártók
          fejlesztéseit.
        </li>
        <li>
          <b>INTÉZMÉNYI ÉS SZAKMAI SZEREPLŐKNEK:</b
          ><span class="turquoise">
            Akik azt keresik, hogyan teremthet valódi értéket a technológia.</span
          >
          Az oktatás, az egészségügy, a közszféra és más szakterületek képviselőinek, akik számára a
          digitalizáció és a mesterséges intelligencia már nem elméleti kérdés, hanem egyre inkább a
          mindennapi működés része.
        </li>
        <li>
          <b>A JÖVŐ SZAKEMBEREINEK:</b
          ><span class="turquoise"> Akik kíváncsiak arra, merre tart a technológiai világ.</span>
          Egyetemi hallgatóknak, pályakezdőknek és a digitális innováció iránt érdeklődőknek, akik
          szeretnének találkozni a szakma szereplőivel, új technológiákat megismerni és közelebb
          kerülni a jövő lehetőségeihez.
        </li>
      </ul>

      <p class="font-bold"
        >Más területről érkezünk. Más kérdéseket teszünk fel. A technológiai változás azonban
        mindannyiunkat érint.</p
      >
      <p class="turquoise">Találkozzunk a SzeBIT 2026-on.</p>
    </div>
  </div>
</div>

<div class="home-block img-and-text-block" id="the-host">
  <div class="home-container">
    <div class="img-container">
      <img
        alt="robot"
        class="bg"
        height="600"
        loading="lazy"
        src="/multimedia/home/the_host.webp"
        width="400"
      />
    </div>
    <div class="text-container">
      <h1>A házigazda</h1>
      <div *appFadeInOnScroll class="fadeInit fadeInRight">
        <p>
          A SZEBIT rendezvényt a <b>PC Trade Systems Kft.</b> szervezi, amely már több mint 20 éve
          vezető szerepet tölt be az informatikai piacon Szegeden és a régióban. Célunk, hogy
          innovatív IT megoldásokkal támogassuk partnereinket a digitális átalakulásban és a jövő
          kihívásaiban. Mindezt az alábbi értékek mentén:
        </p>
        <ul>
          <li>
            <b>Komplex IT megoldások:</b> Szolgáltatásaink széles skálája lefedi az üzleti szektor
            minden igényét, a szoftverfejlesztéstől kezdve az IT infrastruktúra kiépítéséig.
          </li>
          <li>
            <b>Innováció és rugalmasság:</b> Folyamatosan fejlesztjük szolgáltatásainkat, hogy
            lépést tartsunk a technológiai trendekkel és ügyfeleink igényeivel.
          </li>
          <li>
            <b>Társadalmi felelősségvállalás:</b> Büszkék vagyunk arra, hogy elnyertük a
            <b>Családbarát munkahely</b> címet, a <b>Felelős Foglalkoztató</b> minősítést, és
            aktívan támogatjuk a helyi közösséget. Névadó támogatói vagyunk a
            <b>PC Trade Szegedi NKE női kézilabda csapatának</b>, amely a helyi sportélet kiemelkedő
            résztvevője.
          </li>
        </ul>
      </div>
      <div *appFadeInOnScroll class="fadeInit fadeInLeft">
        <h2>Kiemelt tevékenységeink:</h2>
        <ul>
          <li>
            <b>IT szállítás és üzemeltetés:</b> Nagy volumenű hardver és szoftver szállítások,
            valamint az ezekhez kapcsolódó hálózatépítési és teljeskörű szolgáltatások biztosítása.
          </li>
          <li>
            <b>Szoftverfejlesztés:</b> Egyedi szoftvermegoldások fejlesztése és implementálása,
            amelyek ügyfeleink egyedi igényeire szabottak.
          </li>
          <li>
            <b>Edukáció:</b> Küldetésünk a digitalizáció kihívásait minél szélesebb társadalmi
            körrel megismertetni: állandó rendezvényünk a SZEBIT – Szeged Business & IT (<a
              href="https://www.szebit.hu"
              >www.szebit.hu</a
            >), a VIP reggeli - Vezetői IT Percek (<a href="https://www.pctrade.hu/vipreggeli"
              >www.pctrade.hu/vipreggeli</a
            >), de egyszeri rendezvényekkel is szolgáljuk a digitális felzárkóztatást.
          </li>
        </ul>
        <p>
          További részletek és aktualitások A PC Trade Systems Kft.-ről a
          <a href="https://pctrade.hu" target="blank">pctrade.hu</a> a
          <a href="https://facebook.com/pctradekft" target="blank">facebook.com/pctradekft</a>
          oldalakon.
        </p>
      </div>
    </div>
  </div>
</div>
